import type { FC, ReactNode } from 'react';
import ConfirmationModal from 'components/molecules/common/modals/ConfirmationModal';
import { useTpoGenConfig } from '../../../context/CustomerConfigContext';

export interface UnsavedChangesModalProps {
    open: boolean;
    title: string;
    description: ReactNode;
    onContinueEditing: () => void;
    onDiscard: () => void;
}

const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
    open,
    title,
    description,
    onContinueEditing,
    onDiscard,
}) => {
    const tpoGenConfig = useTpoGenConfig();
    return (
        <ConfirmationModal
            open={open}
            title={title}
            okText={tpoGenConfig.labels.modals.continueEditing}
            cancelText={tpoGenConfig.labels.modals.discardChanges}
            loading={false}
            onSubmitClick={onContinueEditing}
            onCancel={onDiscard}
            description={description}
            width={520}
        />
    );
};

UnsavedChangesModal.displayName = 'UnsavedChangesModal';
export default UnsavedChangesModal;
